<template>
  <div class="animated fadeIn mfa-container">
    <div class="loading-header-content">
<!--      <loading-header></loading-header>-->
    </div>
    <div class="margin-side authorization-container" v-on:keyup.enter="submitMfaCodeClick">
      <div class="center-content row">
<!--        <b-img class="img-red-logo" src="/static/img/aduro_horizontal_red_header.svg"/>-->
        <b-img class="img-red-logo" src="/static/img/ic-lock.svg"/>
      </div>
      <div class="text-enter-code-container">
        <div class="enter h2-text">Enter</div>
        <div class="code h1-text">Code</div>
      </div>
      <div class="mfa-description body-text">
        <div>We have sent you a one-time code via {{ mfaType }} to {{mfaTypeValue}}.</div>
        <div>Check your {{ mfaTypeCheck }} and enter the code below</div>

        <div class="text-code-expire">Your code will expire after 10 minutes.</div>
      </div>
      <div class="mfa-input-code">
        <input class="h2-text mfa-input" placeholder="Enter Code Here" type="number" v-model="mfaCode">
        <div class="btn-continue-wrapper">
          <button class="ap-btn primary btn-continue" :disabled="mfaCode == ''" @click="submitMfaCodeClick">Continue</button>
        </div>
        <div class="text-send-new-code body-text" @click="handleRequestNewCodeClick">Send New Code</div>
      </div>

      <AuthorizationSupportLink></AuthorizationSupportLink>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import constCommon from '@/_consts.js';
  import mfaConstants from '@/store/modules/mfa/constants';
  import routerConstanst from '@/router/constants';
  // import constMFA from '@/store/modules/mfa/constants';
  // import LoadingHeader from '@/components/app/LoadingHeader';
  // import EnterAuthorCode from '../EnterAuthorCode';
  import AuthorizationSupportLink from './AuthorizationSupportLink';
  import { censorEmail, censorPhoneNumber } from '@/utils/censor';

  export default {
    name: 'c-enter-authorization-code',
    components: {
      // LoadingHeader,
      AuthorizationSupportLink
      // EnterAuthorCode
    },
    props: {},
    data () {
      return {
        mfaCode: '',
        isLoadingBtn: false
      };
    },
    computed: {
      mfaTypeValue () {
        return this.mfaState.type === constCommon.mfaType.text ? censorPhoneNumber(this.mfaState.mfaData.phone || '') : censorEmail(this.mfaState.mfaData.email || '');
      },
      mfaType () {
        return this.mfaState.type === constCommon.mfaType.email ? 'email' : 'phone';
      },
      mfaTypeCheck () {
        return this.mfaState.type === constCommon.mfaType.email ? 'email' : 'text messages';
      },
      ...mapGetters('mfa', {
        mfaState: mfaConstants.GETTER_MFA_DATA
      })
    },
    methods: {
      submitMfaCodeClick () {
        if (this.mfaCode === '') {
          this.$toast.success('Please enter code below', '', {
            ...this.$toastOpt.optError
          });
          return;
        }
        let data = {
          mfaType: this.mfaState.type,
          token: this.mfaCode,
          action: this.mfaState.flow,
          ...this.mfaState.mfaData
        };
        this.submitMfaCode(data).then((response) => {
          this.saveUserProfile({
            data: response
          });
          this.redirectUser();
        }).catch(error => {
          console.log(error);
          this.$toast.success('Wrong token! Please try again', '', {
            ...this.$toastOpt.optError
          });
        });
      },
      handleRequestNewCodeClick () {
        let data = {
          mfaType: this.mfaState.type,
          token: this.mfaCode,
          action: this.mfaState.flow,
          ...this.mfaState.mfaData
        };
        this.requestNewCode(data).then(response => {
          this.$toast.success('New code sent.', '', {
            ...this.$toastOpt.optSuccess
          });
        }).catch(error => {
          console.log(error);
          this.$toast.success('Server error!', '', {
            ...this.$toastOpt.optError
          });
        });
      },
      // Navigate user view after login
      redirectUser () {
        if ([constCommon.USER_ROLE.clientManager, constCommon.USER_ROLE.accountManager, constCommon.USER_ROLE.eventManager, constCommon.USER_ROLE.admin].indexOf(localStorage.getItem(constCommon.LOCAL_STORE.role)) >= 0) {
          this.$router.replace(constCommon.routeDirect.managerDashboard);
        } else {
          this.$router.push({
            name: routerConstanst.clientDashboard.name,
            params: {
              clientId: localStorage.getItem(constCommon.LOCAL_STORE.clientId)
            }
          });
        }
      },
      ...mapActions('mfa', {
        submitMfaCode: `${mfaConstants.ACTION_CONFIRM_LOGIN_MFA}`,
        requestNewCode: `${mfaConstants.ACTION_SEND_NEW_CODE_MFA}`
      }),
      ...mapMutations({
        saveUserProfile: 'MUTATION_DO_LOGIN'
      })
    },
    created () {
      let token = localStorage.getItem(constCommon.LOCAL_STORE.token);
      if (token) {
        this.redirectUser();
      }
      if (this.mfaState.type === null) {
        this.$router.push('/login');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// EnterAuthorizationCode.vue?19365873